import { InjectionToken } from '@angular/core'

export const DATE_FORMAT = new InjectionToken<string>('DATE_FORMAT')
export const SCREEN_SIZE_TRESH_SMALL = new InjectionToken<number>(
  'SCREEN_SIZE_TRESH_SMALL'
)
